import { Config } from '@catalogo/core-configuration';
import { PageLoadEvent, AddToCartEvent } from '../../../types/events';
import { AddToCartDatalayer } from '../../../types/datalayer/add-to-cart';
import { eventData } from '../../../listen';
import getDefaultEventPayload from '../default-event';

export default (events: eventData, config: Config): void => {
  const addToCart: AddToCartEvent = events['addToCart'][0];
  const pageload: PageLoadEvent = events['page:load'][0];

  const { products } = addToCart.detail;
  const defaultEventPayload = getDefaultEventPayload(pageload, config);

  const event: AddToCartDatalayer = {
    ...defaultEventPayload,
    event: 'addToCart',
    ecommerce: {
      currencyCode: 'BRL',
      add: {
        products: products,
      },
    },
  };

  window.dataLayer = window.dataLayer || [{}];
  window.dataLayer.push(event);
};
